<template>
  <div class="main scroll">
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div @click="$router.back()" class="name" style="margin-top:0">首页</div>
          <div class="icon">></div>
          <div>本学期</div>
          <!-- <a-select
            style="width:160px;margin-left:10px"
            v-model="year"
            size="small"
          >
            <a-select-option key="" :value="0">本学期</a-select-option>
            <a-select-option key="2" :value="2">上学期</a-select-option>
          </a-select> -->

          <span @click="handleRefresh" class="refresh"><a-icon type="redo" />刷新</span>
          
        </div>
        <div class="right">
          <div class="time">
            2025年9月16日到期
          </div>
        </div>
      </div>

      <div class="content">
        <a-row :gutter="10">
          <a-col :span="16">
            <div class="gk card">
              <div class="title">园所概况</div>
              <div class="echart">
              <div>
                <a-progress
                  type="circle"
                  :percent="Number(summary.act_teacher / summary.total_teacher * 100)"
                  :width="100"
                  :strokeWidth="12"
                  strokeColor="#789Ad0"
                >
                  <template #format="percent">
                    <span style="color: red">{{ summary.act_teacher }} </span>
                  </template>
                </a-progress>
                <div class="name">活跃教师数</div>
              </div>

              <div>
                <a-progress
                  type="circle"
                  :percent="Number(summary.act_class / summary.total_class * 100)"
                  :width="100"
                  :strokeWidth="12"
                  strokeColor="#6dc2a9"
                >
                  <template #format="percent">
                    <span style="color: red">{{ summary.act_class }} </span>
                  </template>
                </a-progress>
                <div class="name">活跃班级数</div>
              </div>

              <div>
                <a-progress
                  type="circle"
                  :percent="Number(summary.record_school / summary.total_school * 100)"
                  :width="100"
                  :strokeWidth="12"
                  strokeColor="#ef8887"
                >
                  <template #format="percent">
                    <span style="color: red">{{ summary.record_stu }}</span>
                  </template>
                </a-progress>
                <div class="name">记录幼儿数</div>
              </div>

              <div>
                <a-progress
                  type="circle"
                  :percent="Number(summary.record_family / summary.total_family * 100)"
                  :width="100"
                  :strokeWidth="12"
                  strokeColor="#a97ab3"
                >
                  <template #format="percent">
                    <span style="color: red">{{ summary.record_family }} </span>
                  </template>
                </a-progress>
                <div class="name">活跃家庭数</div>
              </div>

              <!-- <div>
                <a-progress
                  type="circle"
                  :percent="Number(summary.act_teacher / summary.total_teacher * 100)"
                  :width="100"
                  :strokeWidth="12"
                  strokeColor="#ef8887"
                >
                  <template #format="percent">
                    <span style="color: red">{{ Number(summary.act_teacher / summary.total_teacher * 100) + '%'}}</span>
                  </template>
                </a-progress>
                <div class="name">教师活跃率</div>
              </div> -->
                
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="hy card">
              <div class="title">教师活跃率</div>

              <div id="echart_hy" style="width: 100%; height: 180px"></div>
            </div>
          </a-col>
        </a-row>

        <a-row style="margin-top: 10px;">
          <a-col :span="24">
            <div class="card">
              <div class="title">
                全园班级统计
              </div>

              <a-table :columns="columns" :data-source="data">
                <span slot="grow_up_progress" slot-scope="text, record">
                  <a-progress :percent="text" />
                </span>
                <span slot="action" @click="jump(record)" slot-scope="text, record">
                  <a>查看详情</a>
                </span>
              </a-table>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapState } from "vuex";
import { leaderApi,reportApi } from "../../api/api-director";
import { EventBus } from "../../utils/eventBus";
import { Modal } from "ant-design-vue";

const columns = [
  {
    title: "班级名称",
    key: "class_name",
    dataIndex: "class_name",
    scopedSlots: { customRender: "class_name" },
    align: "center",
  },
  {
    title: "记录幼儿数(占比)",
    dataIndex: "record_student2",
    key: "record_student2",
    align: "center",
  },
  {
    title: "发快速记数",
    dataIndex: "notable_count",
    key: "notable_count",
    align: "center",
  },
  {
    title: "发观察记录数",
    dataIndex: "record_count",
    key: "record_count",
    align: "center",
  },
  {
    title: "成长册进度",
    key: "proggrow_up_progressress",
    dataIndex: "grow_up_progress",
    scopedSlots: { customRender: "grow_up_progress" },
    align: "center",
  },
  {
    title: "活跃家长数",
    key: "record_family",
    dataIndex: "record_family",
    scopedSlots: { customRender: "parents" },
    align: "center",
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    align: "center",
  },
];


export default {
  data() {
    return {
      year: 0,
      columns,
      data:null,
      summary: {
        act_teacher: 0,
        act_class: 0,
        act_family: 0,
        act_school: 0,
        total_teacher: 0,
        total_class: 0,
        total_family: 0,
        total_school: 0,
        record_teacher: 0,
      },
    };
  },
  
  computed: {
    ...mapState(["userInfo","school"])
  },
  methods: {
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        leader_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.school.id || ""
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.allClassList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        this.classList = res.data.data;
      });
    },
    jump(record) {
      console.log(record)
      const classObj = {
        id: record.class_id,
        class_id: record.class_id,
        class_name: record.class_name,
        school_id: record.school_id
      }
      this.$store.state.currentClass = classObj;
      EventBus.$emit("changeClass", classObj);
      this.$router.push({ path: "/director/observe/index" })
    },
    getSummary(type=0) {
      console.log(this.userInfo);
      this.$axios({
        method: "GET",
        url: leaderApi.main + leaderApi.getObserStaticSemester,
        headers: { Authorization: this.$store.state.headers },
        params: {
          page: 1,
          PageSize: 100,
          school_id: this.userInfo.school.id,
          type: type
        },
      }).then((res) => {
        if (res.data.result) {
          this.summary = res.data.data;
          if (this.summary.teacherActivityRate) {
            this.initEchart()
          }
        } else {
          this.summary = {
            act_teacher: 0,
            act_class: 0,
            act_family: 0,
            act_school: 0,
            total_teacher: 0,
            total_class: 0,
            total_family: 0,
            total_school: 0,
            record_teacher: 0,
          }

          Modal.info({
            title: '提示',
            content: '此学期暂无数据',
            okText: '知道了',
            centered: true,
            showCancel: false,
            okType: 'primary',
          })
        }
      });
    },
    getClassSummary(type=0) {
      this.$axios({
        method: "GET",
        url: leaderApi.main + leaderApi.getClassObserStatic,
        headers: { Authorization: this.$store.state.headers },
        params: {
          page: 1,
          PageSize: 100,
          school_id: this.userInfo.school.id,
          type
        },
      }).then((res) => {
        if (res.data.result) {
          this.data = res.data.data.map(arr=> {
            arr.progress = (arr.record_student / arr.total_student * 100).toFixed(0)
            arr.record_student2 = `${arr.record_student}/${arr.total_student}`
            return arr
          })
        }
      });
    },
    initEchart() {
      var dom = document.getElementById("echart_hy")
      var myEcharts = echarts.init(dom);
      const data = this.summary.teacherActivityRate
      if (!data) {
        return
      }
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data.map((item) => item.month),
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              // 显示所有标签
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: 100,
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: [
          {
            name: "活跃率",
            type: "bar",
            barWidth: "60%",
            color: '#79c6af',
            tooltip: {
                color: '#999888'
            },
            //纵坐标加上%
            yAxisIndex: 0,
            label: {
              show: true,
              position: "top",
              formatter: "{c}%",
            },
            data: data.map((item) => (item.rate * 100).toFixed(0)),
          },
        ],
      };
      myEcharts.setOption(option)

      window.onresize = function () {
        myEcharts.resize();
      }
    },

    handleRefresh() {
      this.$axios({
        method: "GET",
        url: reportApi.main + reportApi.refreshSummary,
        headers: { Authorization: this.$store.state.headers },
        params: {
          id: this.school.id,
          cat: 4,
          type: 1
        }
      }).then((res) => {
        if (res.data.result) {
          this.$message.success("刷新成功")
          this.getSummary()
          this.getClassSummary()
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  },
  watch:{
    userInfo() {
      if (this.userInfo.school) {
        this.getSummary()
        this.getClassSummary()
      }
    },
    year() {
        this.getSummary(this.year)
        this.getClassSummary(this.year)
    }
  },
  created() {
    if (this.userInfo && this.userInfo.school) {
      this.getSummary()
      this.getClassSummary()
    }

    setTimeout(() => {
      EventBus.$on("changeSchool", (school) => {
        this.getSummary();
        this.getClassSummary();
      });
    }, 100);
  },
  mounted() {
    this.initEchart()
  }
};
</script>

<style lang="scss" scoped>
.refresh {
  margin-left: 10px;
  cursor: pointer;
}
.name {
  text-align: center;
  margin-top: 10px;
  color: #8a8a8a;
  font-size: 12px;
  font-weight: bold;
}
.right {
  .time {
    font-size: 12px;
  }
}

.gk {
  background: #fff;
  min-height: 240px;
  border-radius: 8px;
  .echart {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: 50px;
  }
}

.hy {
  background: #fff;
  min-height: 240px;
  border-radius: 8px;
}

.card {
  padding: 15px;
  box-sizing: border-box;
}

.content {
  margin-top: 20px;
}

.title {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: bold;
  color: #666;
}


</style>

<style lang="scss">
.ant-table-column-title {
  font-weight: bold!important;
}
</style>
